// Import Libraries
import React from "react";
import { Helmet } from "react-helmet";
import PageSEO from "../../../../Components/SEO/PageSEO";

// Import Components
import HeroComponent from "../../../../Layout/Components/HeroComponent/HeroComponent";
import AboutUsComponent from './AboutUsComponent/AboutUsComponent';
import WhyChooseUsComponent from './WhyChooseUsComponent/WhyChooseUsComponent';
import ReviewsComponent from './Components/ReviewsComponent/ReviewsComponent';

// Import Animations
import FadeInOnScroll from "../../../../util/Animations/FadeInOnScroll";

const WhoIsWebNXPage = () => {
  // Define structured data for the company/about page
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "WebNX",
    "url": "https://webnx.com",
    "logo": "https://webnx.com/images/logo.png",
    "foundingDate": "1999",
    "description": "WebNX is a leading provider of enterprise internet infrastructure solutions, offering dedicated servers, colocation services, and high-performance hosting since 1999. With data centers in Ogden, Los Angeles, and Manhattan, we deliver exceptional service with 24/7 support.",
    "founder": {
      "@type": "Person",
      "name": "WebNX Founder"
    },
    "location": [
      {
        "@type": "Place",
        "name": "WebNX Ogden Data Center",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Ogden",
          "addressRegion": "UT",
          "addressCountry": "US"
        }
      },
      {
        "@type": "Place",
        "name": "WebNX Los Angeles Data Center",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Los Angeles",
          "addressRegion": "CA",
          "addressCountry": "US"
        }
      },
      {
        "@type": "Place",
        "name": "WebNX Manhattan Data Center",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Manhattan",
          "addressRegion": "NY",
          "addressCountry": "US"
        }
      }
    ],
    "knowsAbout": [
      "Dedicated Servers",
      "Colocation Services",
      "Enterprise Hosting",
      "Data Center Operations",
      "Network Infrastructure"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "WebNX Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "name": "Dedicated Servers",
          "description": "High-performance dedicated servers with instant provisioning"
        },
        {
          "@type": "Offer",
          "name": "Colocation Services",
          "description": "Enterprise-grade colocation in multiple US locations"
        },
        {
          "@type": "Offer",
          "name": "GPU Servers",
          "description": "Specialized servers for AI and high-performance computing"
        }
      ]
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Lee Miles"
        },
        "reviewBody": "We have benefited from 3 years amazing VOIP phone system and super-fast and reliable internet service from WebNX."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Samuel Draney"
        },
        "reviewBody": "Unbelievably quick service and quality hardware."
      }
    ],
    "areaServed": [
      {
        "@type": "State",
        "name": "Utah"
      },
      {
        "@type": "State",
        "name": "California"
      },
      {
        "@type": "State",
        "name": "New York"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/WebNX/",
      "https://www.linkedin.com/company/webnx/"
    ]
  };

  return (
    <>
      <PageSEO
        title="About WebNX | Enterprise Internet Infrastructure Solutions Since 1999"
        description="Learn about WebNX's journey since 1999 providing exceptional web hosting, dedicated servers, and colocation services. With data centers in Ogden, Los Angeles, and Manhattan, we deliver enterprise-grade solutions with outstanding customer support and reliability."
        keywords="about WebNX, WebNX history, enterprise hosting provider, data center company, dedicated server provider, colocation services, WebNX locations, WebNX support, enterprise infrastructure, hosting company history"
        path="/about"
        image="https://webnx.com/assets/about-webnx.jpg"
        schema={aboutSchema}
        socialProfiles={{
          facebook: "https://www.facebook.com/WebNX/",
          linkedin: "https://www.linkedin.com/company/webnx/"
        }}
      />

      {/* Hero Section */}
      {/* <HeroComponent
        title="About Us"
        subtitle="Who Is WebNX?"
        showButton1={false}
        showButton2={false}
      /> */}

      {/* About Us Section */}
      <FadeInOnScroll>
        <AboutUsComponent />
      </FadeInOnScroll>

      {/* Why Choose Us Section */}
      <FadeInOnScroll>
        <WhyChooseUsComponent />
      </FadeInOnScroll>

      {/* Reviews Section */}
      <ReviewsComponent />
    </>
  );
};

export default WhoIsWebNXPage;
